import React, { lazy } from 'react';
import { useSelector } from 'react-redux';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { PERMISSIONS } from '../../config/permissions';

const NotFound = lazy(() => import('../../container/pages/404'));
const Revenue = lazy(() => import('../../container/report/revenue'));
const Inventory = lazy(() => import('../../container/report/inventory'));

function ReportRoutes() {
  const permissions = useSelector((state) => state.auth.user.permissions);
  const { path } = useRouteMatch();

  return (
    <Switch>
      {permissions.includes(PERMISSIONS.report.sub.revenue.view.value) && <Route exact path={`${path}/revenue`} component={Revenue} />}
      {permissions.includes(PERMISSIONS.report.sub.inventory.view.value) && <Route exact path={`${path}/inventory`} component={Inventory} />}
      <Route path="*">
        <NotFound />
      </Route>
    </Switch>
  );
}

export default ReportRoutes;
